import React from "react";
import { Box, Button, Text, useColorMode } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import InsightsSection from "./InsightsSection";
import PlaceholderTile from "./PlaceholderTile";

const TagSection = ({ tagCoOccurrence = [] }) => {
  const { colorMode } = useColorMode();
  const cardBg = colorMode === "light" ? "gray.50" : "gray.600";
  const labelColor = colorMode === "light" ? "gray.600" : "gray.300";
  const navigate = useNavigate();

  const hasData = Array.isArray(tagCoOccurrence) && tagCoOccurrence.length > 0;
  const top = hasData ? tagCoOccurrence.slice(0, 5) : [];

  return (
    <InsightsSection
      title="Tag Stats"
      description="Highest-performing tag combinations across your trades."
    >
      {hasData ? (
        <>
          <Box>
            {top.map((c, i) => (
              <Box key={i} bg={cardBg} rounded="md" p={3} mb={2}>
                <Text fontSize="sm" fontWeight="bold">{c.combo.join(" + ")}</Text>
                <Text fontSize="xs" color={labelColor}>
                  {c.num_trades} trade{c.num_trades === 1 ? "" : "s"} ·
                  {c.win_pct != null ? ` ${c.win_pct}% WR` : ""}
                </Text>
              </Box>
            ))}
          </Box>
          <Button size="sm" onClick={() => navigate("/tag-analytics")}>
            View Tag Analytics →
          </Button>
        </>
      ) : (
        <PlaceholderTile message="No multi-tag trades yet — apply 2+ tags to see combinations." />
      )}
    </InsightsSection>
  );
};

export default TagSection;
